export enum ESpaceDirection {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
